export const passwordValidators = {
  min: 8,
  number: /[0-9]/,
  lowerCase: /[a-z]/,
  upperCase: /[A-Z]/,
  spaces: /^\S+(\s+\S+)*$/,
};
